import { render, staticRenderFns } from "./ArticleRecord.vue?vue&type=template&id=7e2c24a4&scoped=true&"
import script from "./ArticleRecord.vue?vue&type=script&lang=js&"
export * from "./ArticleRecord.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRecord.vue?vue&type=style&index=0&id=7e2c24a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2c24a4",
  null
  
)

export default component.exports